import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Card = ({block, muted, shadow, children, className, ...attributes}) => {
  const cardClass = classNames('card', className, {
    'card-block': block,
    'bg-light': muted,
    'card-shadow': shadow
  });
  return (
    <div {...attributes} className={cardClass}>
      {children}
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node
  ]),
  block: PropTypes.bool,
  shadow: PropTypes.bool,
  muted: PropTypes.bool,
  className: PropTypes.string
};

export default Card;
